// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".requiredRow:before {\n  content: \"*\";\n  color: red;\n  padding-right: 2px;\n}", ""]);
// Exports
module.exports = exports;
